<template>
    <b-row style="position:relative;" v-bind:class="[{ busy: busy}, 'opacity-transition']">
        <pb-spinner v-if="busy"></pb-spinner>
        <b-col>
            <b-form-group
                    :id="name"
                    :label="label"
                    :label-for="name">
                <v-select
                        :disabled="busy"
                        id="deliveryAddress_select"
                        :searchable="true"
                        :clearable="false"
                        @input="update"
                        label="name"
                        :reduce="category => category.id"
                        :value="value"
                        :options="categories">
                </v-select>
            </b-form-group>
        </b-col>
    </b-row>
</template>

<script>
    import CategoryApi from "../../../../../shared/_api/category";

    export default {
        name: 'CategorySelect',
        props: ['placeholder', 'label', 'name', 'value', 'inline'],
        data() {
            return {
                categories: [],
                selectedCategory: null,
                busy: false
            };
        },
        mounted() {
            this.busy = true;
            CategoryApi.all().then((categories) => {
                let res = [];

                const cb = (e) => {
                    res.push({
                        id: e.id,
                        name: e.webName,
                    });
                    e.childrenCategoryList && e.childrenCategoryList.forEach(cb);
                };

                categories.forEach(cb);

                this.categories = res;
            }).finally(() => {
                this.busy = false;
            })
        },
        methods: {
            update: function (category) {
                this.$emit('input', category);
            }
        }
    }

</script>

<style lang="scss" scoped>
</style>